import React from 'react';

import { SectionCard } from '~components';
import StatisticStack from '~components/visualisation/statistic/Statistics';

interface ComponentProps {
  title: string;
  description: string;
  subDescription?: string;
  items?: { value: number | string; label: string; badge?: string; badgeColor?: string }[];
}

const Summary: React.FC<ComponentProps> = ({ title, description, subDescription, items }) => {
  return (
    <SectionCard title={title} description={description} subDescription={subDescription}>
      <StatisticStack
        statistics={
          items?.map(({ label, value, badge, badgeColor }) => ({
            title: label,
            type: 'value',
            value,
            pill: badge ? { label: badge, color: badgeColor || '#000000ff' } : undefined,
          })) ?? []
        }
      />
    </SectionCard>
  );
};

export default Summary;
